import type { IIndustryCodesFilterDto } from "app/pages/sales-intelligence/domain/industry/types/filter-values";
import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";

const processIndustryCodesFilter = (filterDto: IIndustryCodesFilterDto): ReadonlyArray<keyof LeadsSearchRow> => {
    const columns: Array<keyof LeadsSearchRow> = [];

    if (filterDto.naicsCodes.length > 0) {
        columns.push("naics_codes");
    }

    if (filterDto.sicCodes.length > 0) {
        columns.push("sic_codes");
    }

    return columns;
};

export default processIndustryCodesFilter;
